import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@zitiu/shared-types/database";

export type { SupabaseClient } from "@supabase/supabase-js";

export function createSupabaseClient(config: {
  url: string;
  anonKey: string;
}): SupabaseClient<Database> {
  if (!config.url) {
    throw new Error(
      "createSupabaseClient: `url` is required. Ensure VITE_SUPABASE_URL is set in your .env file.",
    );
  }
  if (!config.anonKey) {
    throw new Error(
      "createSupabaseClient: `anonKey` is required. Ensure VITE_SUPABASE_PUBLISHABLE_KEY is set in your .env file.",
    );
  }

  return createClient<Database>(config.url, config.anonKey, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      // Disable navigator.locks — it deadlocks on page refresh in some browsers.
      // Safe because each app has a single Supabase client instance (no cross-tab sync needed).
      lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<unknown>) => {
        return await fn();
      },
    },
  });
}
